import { isEmpty, isNumber, isNil, isFinite } from 'lodash-es';

import { isValidCellPhone, isValidEmail } from '@ecp/common/src/utils/InputValidateUtils';
import { SiteNumberFunc } from '@ecp/common/src/const/site/siteNumberConst';

import { Custom_Preset } from '@bo-ibSheet/common';
import { MEMBER_ENTRY_MEAN_CODE_LIST } from '@bo-const/member/memberConst';

export const MBR_ERR_CODE = {
  MBR_0001: '중복된 아이디가 존재합니다.',
};

const getSubsidiaryDropDownData = (subsidiaryList) => {
  const subsidiaryCompanyCode = subsidiaryList
    .map(item => item.subsidiaryCompanyCode)
    .join('|');

  const subsidiaryCompanyName = subsidiaryList
    .map(item => item.subsidiaryCompanyName)
    .join('|');

  return {
    subsidiaryCompanyCode: subsidiaryCompanyCode ? `|${subsidiaryCompanyCode}` : '',
    subsidiaryCompanyName: subsidiaryCompanyName ? `|${subsidiaryCompanyName}` : '',
  }
};

export const gridOptions = {
  Cols: [
    { ...Custom_Preset.RowIndex, CanEdit: 0, Visible: 0, CanExport: 0 },
    {
      Header: '회원명',
      Type: 'Text',
      Name: 'memberName',
      Key: 'MBR_NM',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '아이디',
      Type: 'Text',
      Name: 'loginId',
      Key: 'LOGIN_ID',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '비밀번호',
      Type: 'Text',
      Name: 'password',
      MinWidth: 150,
      CanSort: 0,
      Required: 1,
    },
    {
      Header: '계열사번호',
      Type: 'Text',
      Name: 'subsidiaryCompanyCode',
      Key: 'SBCOM_CD',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '사번',
      Type: 'Text',
      Name: 'employNumber',
      Key: 'EMP_NO',
      MinWidth: 150,
    },
    {
      Header: '회원구분',
      Type: 'Enum',
      Name: 'memberDivisionCode',
      Key: 'MBR_DIVI_CD',
      MinWidth: 150,
      DefaultValue: '20',
      Enum: '|준회원',
      EnumKeys: '|20',
    },
    {
      Header: '이메일주소',
      Type: 'Text',
      Name: 'email',
      Key: 'EMAIL',
      MinWidth: 150,
    },
    {
      Header: '휴대전화번호',
      Type: 'Text',
      Name: 'cellphoneNumber',
      Key: 'CELL_NO',
      MinWidth: 150,
    },
    Custom_Preset.ErrorDescription,
  ],
};

const memberRegValidators = (subsidiaryCodeList) => ({
  getInitialAccumulator: () => ({}),
  memberName: [
    {
      when: ['created'],
      message: '회원명을 입력해 주세요.',
      validator: ({ memberName }) => !isEmpty(memberName),
    },
  ],
  loginId: [
    {
      when: ['created'],
      message: '아이디를 입력해 주세요.',
      validator: ({ loginId }) => !isEmpty(loginId),
    },
    {
      when: ['created'],
      message: '영문,숫자만 입력해 주세요.',
      validator: ({ loginId }) => {
        const idRegex = /^[a-zA-Z0-9-_.!]+$/;
        return idRegex.test(loginId);
      },
    },
  ],
  subsidiaryCompanyCode: [
    {
      when: ['created'],
      message: '계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => !isEmpty(subsidiaryCompanyCode),
    },
    {
      when: ['created'],
      message: '등록된 계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => subsidiaryCodeList.includes(subsidiaryCompanyCode),
    },
  ],
  password: [
    {
      when: ['created'],
      message: '비밀번호를 입력해 주세요.',
      validator: ({ password }) => !isEmpty(password),
    },
  ],
  email: [
    {
      when: ['created'],
      message: '이메일 양식에 맞게 입력해주세요.',
      validator: ({ email }) => !email || isValidEmail(email),
    },
  ],
  cellphoneNumber: [
    {
      when: ['created'],
      message: '핸드폰 양식에 맞게 입력해주세요.',
      validator: ({ cellphoneNumber }) => !cellphoneNumber || isValidCellPhone(cellphoneNumber),
    },
  ],
  memberDivisionCode: [
    {
      when: ['created'],
      message: '준회원만 입력 가능합니다.',
      validator: ({ memberDivisionCode }) =>
        memberDivisionCode.toString() === '20' || isEmpty(memberDivisionCode.trim()),
    },
  ],
});

/** 출산선물몰 **/
const gridOptionsBaby = {
  Cols: [
    { ...Custom_Preset.RowIndex, CanEdit: 0, Visible: 0, CanExport: 0 },
    {
      Header: '회원명',
      Type: 'Text',
      Name: 'memberName',
      Key: 'MBR_NM',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '아이디',
      Type: 'Text',
      Name: 'loginId',
      Key: 'LOGIN_ID',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '비밀번호',
      Type: 'Text',
      Name: 'password',
      MinWidth: 150,
      CanSort: 0,
      Required: 1,
    },
    {
      Header: '계열사번호',
      Type: 'Text',
      Name: 'subsidiaryCompanyCode',
      Key: 'SBCOM_CD',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '회원구분',
      Type: 'Enum',
      Name: 'memberDivisionCode',
      Key: 'MBR_DIVI_CD',
      MinWidth: 150,
      DefaultValue: '20',
      Enum: '|준회원',
      EnumKeys: '|20',
    },
    {
      Header: '이메일주소',
      Type: 'Text',
      Name: 'email',
      Key: 'EMAIL',
      MinWidth: 150,
    },
    {
      Header: '휴대전화번호',
      Type: 'Text',
      Name: 'cellphoneNumber',
      Key: 'CELL_NO',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '출산자녀수',
      Type: 'Text',
      Name: 'childNum',
      Key: 'CHILD_NUM',
      MinWidth: 150,
      Required: 1,
    },
    Custom_Preset.ErrorDescription,
  ],
};

const memberRegValidatorsBaby = (subsidiaryCodeList) => ({
  getInitialAccumulator: () => ({}),
  memberName: [
    {
      when: ['created'],
      message: '회원명을 입력해 주세요.',
      validator: ({ memberName }) => !isEmpty(memberName),
    },
  ],
  loginId: [
    {
      when: ['created'],
      message: '아이디를 입력해 주세요.',
      validator: ({ loginId }) => !isEmpty(loginId),
    },
    {
      when: ['created'],
      message: '영문,숫자만 입력해 주세요.',
      validator: ({ loginId }) => {
        const idRegex = /^[a-zA-Z0-9-_.!]+$/;
        return idRegex.test(loginId);
      },
    },
  ],
  subsidiaryCompanyCode: [
    {
      when: ['created'],
      message: '계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => !isEmpty(subsidiaryCompanyCode),
    },
    {
      when: ['created'],
      message: '등록된 계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => subsidiaryCodeList.includes(subsidiaryCompanyCode),
    },
  ],
  password: [
    {
      when: ['created'],
      message: '비밀번호를 입력해 주세요.',
      validator: ({ password }) => !isEmpty(password),
    },
  ],
  email: [
    {
      when: ['created'],
      message: '이메일 양식에 맞게 입력해주세요.',
      validator: ({ email }) => !email || isValidEmail(email),
    },
  ],
  cellphoneNumber: [
    {
      when: ['created'],
      message: '핸드폰 양식에 맞게 입력해주세요.',
      validator: ({ cellphoneNumber }) => isValidCellPhone(cellphoneNumber),
    },
  ],
  memberDivisionCode: [
    {
      when: ['created'],
      message: '준회원만 입력 가능합니다.',
      validator: ({ memberDivisionCode }) =>
        memberDivisionCode.toString() === '20' || isEmpty(memberDivisionCode.trim()),
    },
  ],
  childNum: [
    {
      when: ['created'],
      message: '출산자녀수를 0보다 크고 10보다 작은 숫자로 입력해 주세요.',
      validator: ({ childNum }) => {
        const num = Number(childNum);
        return !isNil(num) && isNumber(num) && isFinite(num) && num > 0 && num < 10;
      },
    },
  ],
});

export const getGridOptions = (siteNumber, entryMeanCode, isCODomain = false, subsidiaryList = []) => {
  let result = gridOptions;

  if (SiteNumberFunc.isBaby(siteNumber)) {
    result = gridOptionsBaby;
  }

  /*
    isCODomain 분기점 기준으로 다음과 같이 작업 진행!!!
    - 사이트별 gridOption이 달라진다면 위에서 작업
    - 사이트 구분없이 공통으로 적용되어야 하는 경우는 아래에서 작업
    
    CO 회원등록 컬럼 = BO 회원등록 (사이트별 추가/삭제/수정 없는 순수) 공통 컬럼 + 사번
  */
  if (isCODomain) {
    result = gridOptions;

    const employNumberData = {
      Header: '사번',
      Type: 'Text',
      Name: 'employNumber',
      Key: 'EMPLOY_NUMBER',
      MinWidth: 150,
      Required: 0,
    };

    result = {
      ...result,
      Cols: result.Cols.flatMap((col) =>
        col.Name === 'subsidiaryCompanyCode' ? [employNumberData, col] : [col]
      ),
    };
  }

  if (MEMBER_ENTRY_MEAN_CODE_LIST.includes(entryMeanCode)) {
    const childNumData = {
      Header: '인증코드',
      Type: 'Text',
      Name: 'memberCertificationInfo',
      Key: 'MEMBER_CERTIFICATION_INFO',
      MinWidth: 150,
      Required: 0,
    };
    result = {
      ...result,
      Cols: result.Cols.flatMap((col) =>
        col.Name === Custom_Preset.ErrorDescription.Name ? [childNumData, col] : [col]
      ),
    };
  }
  // 계열사정보 존재하는 경우, dropDown으로 변경
  if (subsidiaryList.length > 0){
    const { subsidiaryCompanyCode, subsidiaryCompanyName } = getSubsidiaryDropDownData(subsidiaryList);
    const dropDownData = {
      ...Custom_Preset.DropDown,
      Header: '계열사번호',
      Name: 'subsidiaryCompanyCode',
      Key: 'SBCOM_CD',
      MinWidth: 150,
      Required: 0,
      Enum: subsidiaryCompanyName,
      EnumKeys: subsidiaryCompanyCode,
    };
    result = {
      ...result,
      Cols: result.Cols.flatMap((col) =>
        col.Name === 'subsidiaryCompanyCode' ? [dropDownData] : [col]
      ),
    };
  }

  return result;
};

export const getMemberRegValidators = (siteNumber, subsidiaryCodeList, isCODomain = false) => {
  if (isCODomain) {
    return memberRegValidators(subsidiaryCodeList);
  }
  if (SiteNumberFunc.isBaby(siteNumber)) {
    return memberRegValidatorsBaby(subsidiaryCodeList);
  }
  return memberRegValidators(subsidiaryCodeList);
};